@if (entry.base?.display) {
  <div class="center-me">
    <h3 class="no-margins no-paddings">PRODUCER'S CERTIFICATE</h3>
    <p class="italic-bold">Attention Producer:</p>
    <p class="big-bold">If you have questions concerning the completion of this application, please call the Producer Line at 800-652-9459. Option 2 (ACA), then Option 1. Email: PRODEM&#64;highmark.com</p>
    <p>If this section is not fully completed, commission will not be paid</p>
  </div>
}